import { LitElement, html, css, styleMap, utils } from '@hh/global.js'
class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    }
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'

    this._state = -1
    this.doSettings = this.doSettings.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    setTimeout(() => {
      this.doSettings()
    }, 0)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  get includeSpacing() {
    return this.getAttribute('include-spacing') === 'true'
  }

  get _spacerHeight() {
    if (this.includeSpacing) {
      if (this.classList.contains('hh-sticky-header--is-transparent-mobile') &&
        window.matchMedia("(max-width: 749px)").matches
      ) {
        return this._announcementBarHeight
      }
      return this._height
    } else {
      return this._announcementBarHeight
    }
  }

  doSettings() {
    this.setSpacerHeight()
  }

  setSpacerHeight() {
    const announcmentBarEl = this.querySelector('hh-announcement-bar')
    const headerEl = this.querySelector('hh-header')

    const { height: announcementBarHeight } = announcmentBarEl?.getBoundingClientRect() || { height: 0 }
    const { height: headerHeight } = headerEl?.getBoundingClientRect() || { height: 0 }

    document.documentElement.style.setProperty(
      '--hh-announcment-bar-height',
      `${announcementBarHeight}px`
    )

    document.documentElement.style.setProperty(
      '--hh-header-height',
      `${headerHeight}px`
    )

    this._state = 0

    const height = announcementBarHeight + headerHeight
    this._announcementBarHeight = announcementBarHeight
    this._height = height

    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);
    document.querySelector(':root').style.setProperty(`--hh-header-inner-height`, `${this._height}px`);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }


    this.classList[this._state ? 'add' : 'remove']("hh-sticky-header--has-scrolled")
    this.classList[(this._state === 1) ? 'add' : 'remove']("hh-sticky-header--hide-announcement")

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1
    document.querySelector(':root').style.setProperty(`--hh-header-height`, `0px`);

    const announcmentBarEl = this.querySelector('hh-announcement-bar')
    const { height: announcementBarHeight } = announcmentBarEl?.getBoundingClientRect() || { height: 0 }
    document.querySelector(':root').style.setProperty
      (`--hh-header-visible-height`,
      `${(this._height - announcementBarHeight)}px`
    );

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    if (this._state === 2) {
      return
    }
    this.doSettings()
    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);
    document.querySelector(':root').style.setProperty(`--hh-header-visible-height`, `${this._height}px`);
    this._state = 2
  }

  reset() {
    this.classList.remove('hh-sticky-header--has-scrolled')
    if (this._state === 0) {
      return
    }
    this.doSettings()
    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);
    document.querySelector(':root').style.setProperty(`--hh-header-visible-height`, `${this._height}px`);
    this._state = 0
  }

  render() {
    return html`<div
        class="container"
        style="${styleMap({
          position: this._state === -1 ? 'relative' : 'fixed',
          transform: this._state === 1 ? `translateY(-100%)` : 'translateY(0)',
        })}"
      >
        <slot></slot>
      </div>
      <div
        class="spacer"
        style="${styleMap({
          height: `${this._spacerHeight}px`,
        })}"
      ></div>`
  }

  static styles = css`
    .container {
      left: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration-long, 500ms);
      background-color: var(--hh-background, transparent);
    }

    .spacer {
      position: relative;
    }
  `
}

customElements.define('hh-sticky-header', HHStickyHeader)
